import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  env: any = {};


  setEnvironment(env: unknown){
    this.env = env;
  }

  getEnvironment(){
    return this.env;
  }
}
